import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { PaperlessPreferencesApp } from 'document-management-lib';
import ApiUtils from '../../utils/ApiUtils';
import SessionStore from '../../stores/SessionStore';
import envConfig from '../../../static/config';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import PreferenceActionCreator from '../../actions/PreferenceActionCreator';
import {
  AUTO_CHECK,
  STANDARD,
  HELMET_TEXT,
} from '../../constants/PreferencesConstants';
import PreferencesStore from '../../stores/PreferencesStore';
import { getBrandId } from '../../utils/BrandUtils';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';
import NBAStore from '../../stores/NBAStore';
import NBAActionCreator from '../../actions/NBAActionCreator';
import StringConstants from '../../constants/StringConstants';
import NBAPayload from '../nba/NBAPayload';
import config from '../../config/index';
import NBABL from '../nba/NBABL';

const getConfigInfo = () => {
  const accessToken =
    SessionStore.getURLTokenValue() || SessionStore.getToken()['access_token'];
  return {
    clientContext: ApiUtils.getApiClientContext(),
    accessToken,
    bankId: SessionStore.getSessionBankID(),
    apiBaseUrlPAAS: `${envConfig.apiBaseUrlPAAS}/ibapi/v2`,
    apiBaseUrl: envConfig.apiBaseUrl,
    brandId: getBrandId(),
    showTransactionAlert: envConfig.isTransactionAlertEnabled,
  };
};

class PaperFreePreferences extends React.Component {
  constructor(props) {
    super(props);
    this.handlePreferencesUpdate = this.handlePreferencesUpdate.bind(this);
    this.configureLeavePopup = this.configureLeavePopup.bind(this);
    this.resetGoHome = this.resetGoHome.bind(this);

    this.state = {
      mode: PreferencesStore.getMode(),
      unblock: undefined,
      triggerGoHome: false,
    };
  }

  componentWillMount() {
    const { listenBefore } = this.props.history;

    this.setState({
      unblock: listenBefore((location, callback) => {
        if (PreferencesStore.getUpdateStatus()) {
          callback(false);
          this.configureLeavePopup(true);
          this.setState({ triggerGoHome: true });
        } else {
          callback(true);
        }
      }),
    });
  }

  componentWillUnmount() {
    // remove the listener blocking route transition
    this.state.unblock();
  }

  handlePreferencesUpdate = (updated) => {
    const splash = NBABL.getSplashData(NBAStore.getNBAData());
    if (splash && updated === false) {
      NBAActionCreator.sendSplashAcknowledgement(
        StringConstants.ACCTSUMM,
        NBAPayload.nbaContainerUserInteraction(
          splash.id,
          splash.offerId,
          config.analytics.analytics_behaviour_positive
        )
      );
    }
    PreferenceActionCreator.setUpdateStatus(updated);
    if (updated && PreferencesStore.getMode() === AUTO_CHECK) {
      PreferenceActionCreator.setMode(STANDARD);
    }
    this.configureLeavePopup(updated);
  };

  configureLeavePopup(displayLeavePopup) {
    const isAuto = PreferencesStore.getMode() === AUTO_CHECK;
    const {
      preferencesPopupWarningHeaderManage,
      preferencesPopupWarningBodyManage,
      preferencesPopupWarningHeaderAuto,
      preferencesPopupWarningBodyAuto,
      preferencesLeavePageBtn,
      preferencesContinuePageBtn,
    } = this.props.content;

    const modalConfig = {
      displayLeavePopup,
      title: isAuto
        ? preferencesPopupWarningHeaderAuto
        : preferencesPopupWarningHeaderManage,
      body: isAuto
        ? preferencesPopupWarningBodyAuto
        : preferencesPopupWarningBodyManage,
      secondaryButtonText: preferencesLeavePageBtn,
      primaryButtonText: preferencesContinuePageBtn,
    };
    SiteHeaderActionCreator.setModalConfig(modalConfig);
  }

  resetGoHome() {
    this.setState({ triggerGoHome: false });
  }

  render() {
    const configInfo = getConfigInfo();
    const session = {
      access_token: configInfo.accessToken,
      bank_id: configInfo.bankId === 'DYB' ? 'CB' : configInfo.bankId,
      brand: configInfo.brandId,
    };

    const clientContext = JSON.parse(configInfo.clientContext);

    return (
      <div id="page" className="bow page">
        <Helmet title={HELMET_TEXT} />
        <div className="web-ui-components">
          <PaperlessPreferencesApp
            handlePreferencesUpdate={this.handlePreferencesUpdate}
            session={session}
            client={clientContext}
            environment={configInfo}
            autoCheck={this.state.mode === AUTO_CHECK}
            nativePromptBeforeUnload={false}
            isSMEUser={this.props.isSMEUser}
          />
        </div>
      </div>
    );
  }
}

PaperFreePreferences.propTypes = {
  history: PropTypes.any.isRequired,
  isSMEUser: PropTypes.bool.isRequired,
  content: PropTypes.shape({
    preferencesPopupWarningHeaderManage: PropTypes.string.isRequired,
    preferencesPopupWarningHeaderAuto: PropTypes.string.isRequired,
    preferencesPopupWarningBodyAuto: PropTypes.string.isRequired,
    preferencesPopupWarningBodyManage: PropTypes.string.isRequired,
    preferencesLeavePageBtn: PropTypes.string.isRequired,
    preferencesContinuePageBtn: PropTypes.string.isRequired,
  }).isRequired,
};
export default RequiresAuthenticatedUser(PaperFreePreferences);
